import React from "react";
import {
  Linkedin,
  Facebook,
  Instagram,
  Twitter,
  Github,
  Youtube,
  Globe,
  Link as LinkIcon,
} from "lucide-react";

const ICON_MAP = {
  linkedin: Linkedin,
  facebook: Facebook,
  instagram: Instagram,
  x: Twitter,
  github: Github,
  youtube: Youtube,
  behance: Globe,
  dribbble: Globe,
  medium: Globe,
  gitlab: Globe,
  tiktok: Globe,
  whatsapp: Globe,
  telegram: Globe,
  discord: Globe,
  website: Globe,
  other: LinkIcon,
};

const COLOR_MAP = {
  linkedin: "#0A66C2",
  facebook: "#1877F2",
  x: "#000000",
  instagram: "#E4405F",
  github: "#181717",
  youtube: "#FF0000",
  behance: "#1769FF",
  dribbble: "#EA4C89",
  medium: "#000000",
  gitlab: "#FC6D26",
  tiktok: "#000000",
  whatsapp: "#25D366",
  telegram: "#26A5E4",
  discord: "#5865F2",
  website: "#6B7280",
  other: "#6B7280",
};

const LABEL_MAP = {
  linkedin: "LinkedIn",
  facebook: "Facebook",
  x: "X",
  instagram: "Instagram",
  github: "GitHub",
  youtube: "YouTube",
  behance: "Behance",
  dribbble: "Dribbble",
  medium: "Medium",
  gitlab: "GitLab",
  tiktok: "TikTok",
  whatsapp: "WhatsApp",
  telegram: "Telegram",
  discord: "Discord",
  website: "Website",
  other: "Link",
};

export default function LinksDisplay({ links }) {
  if (!links || links.length === 0) return null;
  return (
    <div className="mt-4 w-full flex flex-wrap gap-2 justify-center">
      {links.map((link, index) => {
        const Icon = ICON_MAP[link.type] || LinkIcon;
        const color = COLOR_MAP[link.type] || "#6B7280";
        const label = link.label || LABEL_MAP[link.type] || "Link";
        return (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            title={label}
            className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-gray-200 hover:border-gray-300 transition-colors hover:shadow-sm"
            style={{ color }}
          >
            <Icon className="w-4 h-4" />
          </a>
        );
      })}
    </div>
  );
}